export interface Item {
    items: Item[] | null;
    descriptionKey: string;
    descriptionValues?: string[];
    isAction: boolean;
    resolved: boolean;
}

export enum SourceType {
    LinkedIn = 'LinkedIn',
    CV = 'CV',
}

export enum SectionType {
    Overview = 'overview',
    Languages = 'languages',
    Education = 'study_programs',
    WorkExperience = 'work_experience',
    Memberships = 'memberships',
    Summary = 'summary',
}

export interface Section {
    items: Item[];
    sectionType: SectionType;
}

export interface ProfileImportResult {
    id: string;
    createdAt: Date;
    reviewedAt: Date | null;
    sourceType: SourceType;
    result: {
        sections: Section[];
    };
}

export interface ImportSection {
    id: string;
    section: Section;
    sourceType: SourceType;
    createdAt: Date;
}

export const transformProfileImportResultFromServer = (data: any): ProfileImportResult | null => {
    return data
        ? {
              id: data.id,
              createdAt: data.createdAt,
              reviewedAt: data.reviewedAt,
              sourceType: data.sourceType,
              result: {
                  sections: data.result.sections
                      ? data.result.sections.map(transformSectionFromServer)
                      : [],
              },
          }
        : null;
};

const transformSectionFromServer = (data: any): Section => {
    return {
        sectionType: data.sectionType,
        items: data.items ? data.items.map(transformItemFromServer) : [],
    };
};

const transformItemFromServer = (data: any): Item => {
    return {
        descriptionKey: data.descriptionKey,
        isAction: data.isAction,
        resolved: data.isResolved,
        descriptionValues: data.descriptionValues,
        items: data.items ? data.items.map(transformItemFromServer) : null,
    };
};
